export default "__VITE_PUBLIC_ASSET__6523babf__"